import React from "react";

class EditDataForm extends React.Component {
    updateUser = e => {
        e.preventDefault();
        const form = e.target;

        const userData = {
            firstname: form.firstname.value,
            lastname: form.lastname.value,
            email: form.email.value
        };

        this.props.updateUser(userData, e.target);
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        console.log('Up', this.constructor.name);
        this.updated = true;
    }

    goToCreate = () => {
        this.props.history.push('/');
    }


    render() {
        let formData = this.props.user;

        console.log("Edit Form Data", formData);

        if (!formData) {
            formData = {
                firstname: "",
                lastname: "",
                email: ""
            };
        }


        function EditForm(props) {
            if (props.user) {
                return (
                    <form onSubmit={props.updateUser}>

                        <div className="form-row--multiple">
                            <div className="form-item">
                                <label htmlFor="firstname">First Name</label>
                                <div className="input-input">
                                    <input id="firstname" type="text" placeholder="First Name" name="firstname" required
                                           defaultValue={formData.firstname} title="You should write something here"/>
                                </div>
                            </div>
                            <div className="form-item">
                                <label htmlFor="firstname">First Name</label>
                                <div className="input-input">
                                    <input id="lastname" type="text" placeholder="Last Name" name="lastname" required
                                           defaultValue={formData.lastname} title="Hmm, something missing?"/>
                                </div>
                            </div>
                            <div className="form-item">
                                <label htmlFor="email">Email</label>
                                <div className="input-input">
                                    <input id="email" type="email" placeholder="Email" name="email" required
                                           defaultValue={formData.email}
                                           title="OK, I get it. You don't want any emails, right?"/>
                                </div>
                            </div>
                        </div>
                        <div className="btn-wrp submit-button">
                            <button type="submit">Update Profile</button>
                        </div>
                        <div className="btn-wrp submit-button">
                            <button type="button" onClick={props.deleteProfile}>Delete Profile</button>
                        </div>
                    </form>
                );
            } else {

                return (
                    <div className="btn-wrp submit-button">
                        <button onClick={props.createProfile}>Create a Profile</button>
                    </div>
                )
                // return null;
            }
        }


        return (

            <EditForm user={this.props.user} deleteProfile={this.props.deleteProfile}
                      createProfile={this.goToCreate} updateUser={this.updateUser}/>

        );

    }
}

export default EditDataForm;
